// import React, { useState } from 'react';
// import "../lead/Lead.css";
// import { BASE_URL } from '../../config';

// function AddLead({ props }) {
//   const [isPopupOpen, setIsPopupOpen] = useState(false);
//   const [currentDate, setCurrentDate] = useState(new Date().toISOString().split("T")[0]); 

//   const openPopup = () => setIsPopupOpen(true);
//   const closePopup = () => setIsPopupOpen(false);

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     const form = e.target;

//     const newLead = {
//       name: form.name.value,
//       jobTitle: form.jobTitle.value,
//       companyName: form.companyName.value,
//       email: form.email.value,
//       phoneNumber: form.phoneNumber.value,
//       foundOn: form.foundOn.value, 
//       status: "NEW_LEAD", 
//     };

//     try {
//       const response = await fetch(`${BASE_URL}/createNewLead`, {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify(newLead),
//       });

//       if (response.ok) {
//         alert("Lead created successfully");
//         form.reset();
//         setCurrentDate(new Date().toISOString().split("T")[0]); 
//         closePopup();
//       } else {
//         console.error('Failed to create lead');
//       }
//     } catch (error) {
//       console.error('Error creating lead:', error);
//     }
//   };

//   return (
//     <>
//       <div className="popup">
//         <div className="add_lead_popup_container">
//           <h2>Add New Lead</h2>
//           <div className="closeAddlead" onClick={props}>
//             <button style={{ color: "red" }}>X</button>
//           </div>
//           <form onSubmit={handleSubmit} className='add_lead_form'>
//             <div className="input-containerr">
//               <input type="text" name="name" placeholder=" " required />
//               <label>First Name</label>
//             </div>
//             <div className="input-containerr">
//               <input type="text" name="jobTitle" placeholder=" " required />
//               <label>Job Title</label>
//             </div>
//             <div className="input-containerr">
//               <input type="email" name="email" placeholder=" " required />
//               <label>Email</label>
//             </div>
//             <div className="input-containerr">
//               <input type="text" name="phoneNumber" placeholder=" " required />
//               <label>Phone</label>
//             </div>
//             <div className="input-containerr">
//               <input type="text" name="companyName" placeholder=" " required />
//               <label>Company Name</label>
//             </div>
//             <div className="input-containerr">
//               <input type="date" name="foundOn" value={currentDate} onChange={(e) => setCurrentDate(e.target.value)} required />
//               <label>Found On</label>
//             </div>
//             <button type="submit" className='lead_button'>Submit Lead</button>
//           </form>
//         </div>
//       </div>
//     </>
//   );
// }

// export default AddLead;


import React, { useState, useCallback } from 'react';
import "../lead/Lead.css";
import { BASE_URL } from '../../config';

// Computed once at module load instead of on every render/state update.
const TODAY = new Date().toISOString().split("T")[0];

// Text-style fields rendered via .map() below (dates handled separately since
// they need defaultValue + a "date" type).
const TEXT_FIELDS = [
  { name: 'name', label: 'First Name', type: 'text' },
  { name: 'propertyType', label: 'Property Type', type: 'text' },
  { name: 'location', label: 'Location', type: 'text' },
  { name: 'agent', label: 'Agent', type: 'text' },
  { name: 'jobTitle', label: 'Job Title', type: 'text' },
  { name: 'email', label: 'Email', type: 'email' },
  { name: 'phoneNumber', label: 'Phone', type: 'text' },
  { name: 'companyName', label: 'Company Name', type: 'text' },
];

// Pure, no closure over component state -> defined once, not recreated per render.
function getAuthToken() {
  try {
    const authData = JSON.parse(localStorage.getItem('employeROyalmadeLogin'));
    return authData?.token || null;
  } catch (err) {
    console.error('Could not parse auth data from localStorage:', err);
    return null;
  }
}

function AddLead({ props }) {
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const openPopup = useCallback(() => setIsPopupOpen(true), []);
  const closePopup = useCallback(() => setIsPopupOpen(false), []);

  const handleSubmit = useCallback(async (e) => {
    e.preventDefault();
    const form = e.target;

    const newLead = {
      name: form.name.value,
      propertyType: form.propertyType.value,
      location: form.location.value,
      agent: form.agent.value,
      jobTitle: form.jobTitle.value,
      companyName: form.companyName.value,
      email: form.email.value,
      phoneNumber: form.phoneNumber.value,
      foundOn: form.foundOn.value,
      remark: form.remark.value,
      remarkdate: form.remarkdate.value,
      status: "NEW_LEAD",
    };

    setIsSubmitting(true);
    try {
      const token = getAuthToken();

      const response = await fetch(`${BASE_URL}/createNewLead`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          ...(token ? { Authorization: `Bearer ${token}` } : {}),
        },
        body: JSON.stringify(newLead),
      });

      if (response.ok) {
        alert("Lead created successfully");
        form.reset();
        closePopup();
      } else if (response.status === 401) {
        alert("Session expired or unauthorized. Please log in again.");
        console.error('Unauthorized (401) while creating lead');
      } else {
        console.error('Failed to create lead');
      }
    } catch (error) {
      console.error('Error creating lead:', error);
    } finally {
      setIsSubmitting(false);
    }
  }, [closePopup]);

  return (
    <>
      <div className="popup">
        <div className="add_lead_popup_container add_lead_scroll">
          <h2>Add New Lead</h2>
          <div className="closeAddlead" onClick={props}>
            <button style={{ color: "red" }}>X</button>
          </div>
          <form onSubmit={handleSubmit} className='add_lead_form'>
            {TEXT_FIELDS.map(({ name, label, type }) => (
              <div className="input-containerr" key={name}>
                <input type={type} name={name} placeholder=" " required disabled={isSubmitting} />
                <label>{label}</label>
              </div>
            ))}
            <div className="input-containerr">
              <input type="date" name="foundOn" defaultValue={TODAY} required disabled={isSubmitting} />
              <label>Found On</label>
            </div>
            <div className="input-containerr">
              <textarea name="remark" placeholder=" " required disabled={isSubmitting} />
              <label>Remark</label>
            </div>
            <div className="input-containerr">
              <input type="date" name="remarkdate" defaultValue={TODAY} required disabled={isSubmitting} />
              <label>Remark Date</label>
            </div>
            <button type="submit" className='lead_button' disabled={isSubmitting}>
              {isSubmitting ? (
                <span className="lead_button_loading">
                  <span className="lead_spinner" aria-hidden="true"></span>
                  Submitting...
                </span>
              ) : (
                "Submit Lead"
              )}
            </button>
          </form>
        </div>
      </div>
    </>
  );
}

export default AddLead;